import { cva } from 'class-variance-authority'

export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg font-semibold transition-colors disabled:pointer-events-none disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50',
  {
    variants: {
      variant: {
        primary: 'bg-brand text-white hover:bg-brand-dark shadow-md',
        secondary: 'bg-ink text-white hover:bg-black shadow-md',
        outline: 'border border-line bg-panel text-ink hover:bg-surface',
        ghost: 'text-ink-muted hover:bg-surface hover:text-ink',
        accent: 'bg-accent text-white hover:bg-accent-dark',
        danger: 'bg-danger text-white hover:bg-danger/90',
      },
      size: {
        sm: 'h-8 px-3 text-xs',
        md: 'h-10 px-4 text-sm',
        lg: 'h-12 px-5 text-base',
        icon: 'h-10 w-10',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'md',
    },
  },
)
